import { render } from "./ContentRenderer.vue?vue&type=template&id=f48697cc"
import script from "./ContentRenderer.vue?vue&type=script&lang=js"
export * from "./ContentRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__